import { render } from "./Services.vue?vue&type=template&id=a1336d9e&scoped=true"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"

import "./Services.vue?vue&type=style&index=0&id=a1336d9e&lang=scss&scoped=true"

import exportComponent from "/var/www/nexgen/apps/nxglabs-web/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1336d9e"]])

export default __exports__